import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Box,
Autocomplete,
Chip,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import mgmtSections from "src/services/mgmtSections";
import mgmtProduct from "src/services/mgmtProduct";

const SectionsForm = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [customerId, setCustomerId] = useState("");
  const [sectionTitle, setSectionTitle] = useState("");
  const [sectionText, setSectionText] = useState("");

  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [loadingProducts, setLoadingProducts] = useState(false);

  // Fetch products only after Customer ID input is completed
  const handleCustomerBlur = async () => {
    if (!customerId) {
      setProducts([]);
      setSelectedProducts([]);
      return;
    }

    try {
      setLoadingProducts(true);

      const response =
        await mgmtProduct.getProductDetails(customerId);

      console.log("Products Response:", response);

      setProducts(
        Array.isArray(response) ? response : []
      );

      setSelectedProducts([]);
    } catch (error) {
      console.error(
        "Failed to fetch products:",
        error
      );

      setProducts([]);
      setSelectedProducts([]);

      enqueueSnackbar("Failed to fetch products", {
        variant: "error",
      });
    } finally {
      setLoadingProducts(false);
    }
  };

  const handleProductChange = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) {
        return prevSelected.filter(
          (id) => id !== productId
        );
      }

      return [...prevSelected, productId];
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!customerId) {
  enqueueSnackbar("Customer ID is required", {
    variant: "error",
  });
  return;
}

if (
  !sectionText.trim() &&
  selectedProducts.length === 0
) {
  enqueueSnackbar(
    "Please provide description or select at least one product",
    {
      variant: "error",
    }
  );
  return;
}

    const payload = {
      customerId: Number(customerId),
      sectionTitle: sectionTitle.trim(),
      sectionText: sectionText.trim(),
      products: selectedProducts,
    };

    console.log("Section Payload:", payload);

    try {
      await mgmtSections.createSection(payload);

      enqueueSnackbar(
        "Section created successfully",
        {
          variant: "success",
        }
      );

      navigate("/app/management/sections");
    } catch (error) {
      console.error(
        "Failed to create section:",
        error
      );

      enqueueSnackbar(
        "Failed to create Section",
        {
          variant: "error",
        }
      );
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography
        variant="h4"
        sx={{ mb: 3 }}
      >
        Add Section
      </Typography>

      <Card>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>

              {/* Customer ID */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Customer ID"
                  value={customerId}
                  onChange={(event) =>
                    setCustomerId(event.target.value)
                  }
                  onBlur={handleCustomerBlur}
                  type="number"
                />
              </Grid>

              {/* Section Title */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Section Title"
                  value={sectionTitle}
                  onChange={(event) =>
                    setSectionTitle(event.target.value)
                  }
                />
              </Grid>

              {/* Section Text */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Section Text"
                  value={sectionText}
                  onChange={(event) =>
                    setSectionText(event.target.value)
                  }
                />
              </Grid>

              {/* Products */}
<Grid item xs={12}>
  <Typography
    variant="h6"
    sx={{ mb: 2 }}
  >
    Products
  </Typography>

  <Autocomplete
    multiple
    options={products}
    value={products.filter((product) =>
      selectedProducts.includes(
        product.productSKU || product.productCode
      )
    )}
    getOptionLabel={(product) =>
      product.productName ||
      product.productSKU ||
      product.productCode ||
      ""
    }
    onChange={(event, newValue) => {
      setSelectedProducts(
        newValue.map(
          (product) =>
            product.productSKU ||
            product.productCode
        )
      );
    }}
    loading={loadingProducts}
    isOptionEqualToValue={(option, value) =>
      (option.productSKU || option.productCode) ===
      (value.productSKU || value.productCode)
    }
    renderTags={(value, getTagProps) =>
      value.map((product, index) => {
        const productId =
          product.productSKU ||
          product.productCode;

        return (
          <Chip
            {...getTagProps({ index })}
            key={productId}
            label={`${product.productName} (${productId})`}
          />
        );
      })
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label="Search / Select Products"
        placeholder="Search products"
      />
    )}
  />
</Grid>

              {/* Buttons */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                >
                  Save
                </Button>

                <Button
                  type="button"
                  sx={{ ml: 2 }}
                  onClick={() =>
                    navigate(
                      "/app/management/sections"
                    )
                  }
                >
                  Cancel
                </Button>
              </Grid>

            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectionsForm;